// extracted by mini-css-extract-plugin
export default {"highlight":"FormattedNumber-module__highlight","spaceBefore":"FormattedNumber-module__spaceBefore"};